import React from 'react';
import { formatDate, formatTime } from '../utils/booking';

export default function WaitlistPage({ data, actions }) {
  const groups = data.sessions
    .map((session) => ({
      session,
      type: data.tripTypes.find((type) => type.id === session.trip_type_id),
      entries: data.waitlists.filter(
        (entry) => entry.trip_session_id === session.id && entry.status === 'WAITING'
      )
    }))
    .filter((group) => group.entries.length > 0);

  return (
    <main className="page-shell">
      <div className="page-heading">
        <div>
          <span className="eyebrow">Guide Admin</span>
          <h1>Waitlist</h1>
          <p>Contact customers manually when seats reopen.</p>
        </div>
      </div>
      <div className="waitlist-groups">
        {groups.length === 0 && (
          <div className="admin-table-card empty-small">
            No customers are currently waiting.
          </div>
        )}
        {groups.map(({ session, type, entries }) => (
          <section className="admin-table-card" key={session.id}>
            <div className="waitlist-heading">
              <div>
                <span className="eyebrow">{formatDate(session.date, true)}</span>
                <h2>{type?.name}</h2>
              </div>
              <span>{formatTime(session.start_time)}</span>
            </div>
            {entries.map((entry) => (
              <WaitlistRow key={entry.id} entry={entry} actions={actions} />
            ))}
          </section>
        ))}
      </div>
    </main>
  );
}

function WaitlistRow({ entry, actions }) {
  const [removing, setRemoving] = React.useState(false);

  const remove = async () => {
    setRemoving(true);
    await actions.removeWaitlistEntry(entry.id);
    setRemoving(false);
  };

  return (
    <div className="waitlist-row">
      <div>
        <strong>{entry.name} — Party of {entry.party_size}</strong>
        <small>{entry.email} · {entry.phone}</small>
        {entry.message && <small>{entry.message}</small>}
      </div>
      <button className="text-button danger" onClick={remove} disabled={removing}>
        {removing ? 'Saving…' : 'Remove'}
      </button>
    </div>
  );
}